<portal-menu [portals]="portals"
    [searchable]="true"
    [navigable]="true"
    (portalExpanded)="portalExpanded($event)"
    (portalNavigated)="portalNavigated($event)"
    (expandCollapseClick)="expandCollapseClick($event)"></portal-menu>